import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 12H4M4 12L10.6087 5M4 12L10.6087 19", stroke: "currentColor", strokeWidth: 1.5 }));
export default SvgArrowLeft;
